import { RISK, scoreToLevel } from "@/data/mockData";

// Circular gauge (270deg arc) rendering a 0-100 risk score.
export function RiskGauge({ score = 0, size = 200, stroke = 12 }) {
  const level = scoreToLevel(score);
  const cfg = RISK[level];
  const r = (size - stroke) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const arc = 0.75; // 270 degrees
  const circumference = 2 * Math.PI * r;
  const dash = circumference * arc;
  const progress = dash * (score / 100);

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="risk-score-gauge">
      <svg width={size} height={size} className="-rotate-[135deg]">
        <circle
          cx={cx}
          cy={cy}
          r={r}
          fill="none"
          stroke="#232738"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${circumference}`}
        />
        <circle
          cx={cx}
          cy={cy}
          r={r}
          fill="none"
          stroke={cfg.hex}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${progress} ${circumference}`}
          style={{ transition: "stroke-dasharray 0.6s cubic-bezier(0.16,1,0.3,1), stroke 0.3s" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span
          className="font-mono text-5xl font-bold tabular leading-none"
          style={{ color: cfg.hex }}
          data-testid="risk-score-value"
        >
          {score}
        </span>
        <span className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
          / 100 risk
        </span>
      </div>
    </div>
  );
}
